export const sendEmail = (email: string) => window.open(`mailto:${email}`, '_blank');
